<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Create Project" subTitle="Project Management" />

    <CreateProject />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateProject from "@/components/Pages/ProjectManagement/CreateProject/index.vue";

export default defineComponent({
  name: "CreateProjectPage",
  components: {
    PageTitle,
    CreateProject,
  },
});
</script>
